import Cases from './Cases';

export default Cases;
